import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Modal } from 'react-bootstrap';
import './TransactionCompletion.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import { Link, useNavigate, useParams } from 'react-router-dom';
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import moment from 'moment/moment';
import { gettoastsuccess, gettoastwarning } from '../../../Utils/Common';

const TransactionCompletion = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    const [loading, setLoading] = useState(true);

    const [inputs, setInputs] = useState({ deal_id: '', deal_clipped_id: '', business_id: '', business_name: '', contact_number: '', address: '', pincode: '', state: '', city: '', town: '', deal_unique_id: '', coupon_code: '', deal_type: '', deal_master_type: '', listing_title: '', image: '', description: '', original_mrp: '', buy_qty: '', get_qty: '', sale_price: '', beat_online_price: 'no', online_price: '', online_link: '', deal_start_date: '', deal_end_date: '', monthly_deal_limite: '', home_delivery: 0, town_id: '', redeem_status: '', store_percent_discount: '', store_cash_discount: '', free_item: '', deal_tag: '', discount: '', customer_name: '', date: '',slug:'' });

    // const [images, setImages] = useState([]);

    useEffect(() => {
        document.title = `Transaction Completion | Local Bells`;
        document.getElementById('bodywrap').className = 'netrans';

        let formData = new FormData();
        formData.append('deal_clipped_id', id);
        var url = 'get_user_deal_clipped_detail';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {

                    /*var beat_online_price = 'no';
                    if (response.data.data.deal_master_type === 'specific') {
                        beat_online_price = response.data.data.beat_online_price;
                    }

                    var home_delivery = 0;
                    if (response.data.data.deal_master_type === 'specific') {
                        home_delivery = response.data.data.home_delivery;
                    }*/
                    // console.log('success');
                    setInputs({
                        deal_id: response.data.data.deal_id,
                        deal_clipped_id: response.data.data.deal_clipped_id,
                        business_id: response.data.data.business_id,
                        business_name: response.data.data.business_name,
                        contact_number: response.data.data.contact_number,
                        address: response.data.data.address,
                        pincode: response.data.data.pincode,
                        state: response.data.data.state,
                        city: response.data.data.city,
                        town: response.data.data.town,
                        deal_unique_id: response.data.data.deal_unique_id,
                        coupon_code: response.data.data.coupon_code,
                        deal_type: response.data.data.deal_type,
                        deal_master_type: response.data.data.deal_master_type,
                        listing_title: response.data.data.listing_title,
                        image: response.data.data.image,
                        description: response.data.data.description,
                        original_mrp: response.data.data.original_mrp,
                        buy_qty: response.data.data.buy_qty,
                        get_qty: response.data.data.get_qty,
                        sale_price: response.data.data.sale_price,
                        online_price: response.data.data.online_price,
                        online_link: response.data.data.online_link,
                        deal_start_date: response.data.data.deal_start_date,
                        deal_end_date: response.data.data.deal_end_date,
                        monthly_deal_limite: response.data.data.monthly_deal_limite,
                        town_id: response.data.data.town_id,
                        redeem_status: response.data.data.redeem_status,
                        store_percent_discount: response.data.data.store_percent_discount,
                        store_cash_discount: response.data.data.store_cash_discount,
                        free_item: response.data.data.free_item,
                        deal_tag: response.data.data.deal_tag,
                        discount: response.data.data.discount,
                        customer_name: response.data.data.customer_name,
                        date: response.data.data.date,
                        slug:response.data.data.slug
                    });

                    // setImages(response.data.data.deal_images);

                }
            }).catch(error => {
                setLoading(false);
            });

    }, [id]);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleYes = (e) => {
        e.preventDefault();

        let deal_clipped_id = inputs.deal_clipped_id;

        let formData = new FormData();
        formData.append('deal_clipped_id', deal_clipped_id);
        API.post('deal_clipped_status_change_by_user', formData)
            .then(response => {
                if (response.data.status === false) {
                    gettoastsuccess(response.data.message, '');
                    setShow(false)
                    gettoastwarning(response.data.message, '');
                } else {
                    setShow(false)
                    setInputs(prev => ({
                        ...prev,
                        redeem_status: 1,
                    }));
                    gettoastsuccess(response.data.message, '');
                }
            }).catch(error => {
                setLoading(false);
                gettoastwarning("Something went wrong. Please try again later.", '');
            });

    };

    const shareAll = () => {
        const url = process.env.REACT_APP_BASE_URL+'neighbour/deal-details/'+id;

        navigator.clipboard.writeText(url)
            .then(() => {
                gettoastsuccess('Link copied to clipboard', '');
            })
            .catch(err => {
                console.error('Failed to copy:', err);
            });
    }

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row>
                                    <Col xxl={6} xl={8} lg={12}>
                                        <div className='white-box'>

                                            <div className='tc-top d-none'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/trans-comp.webp'} className="img-fluid" alt="trans-comp" />
                                                <h3>684567-79-1174</h3>
                                            </div>
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <div className='tc-check'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/green-check.webp'} className="img-fluid d-none" alt="green-check" />
                                                    <div>
                                                        <h5>You have successfully Reserved the Great Local Deal. </h5>
                                                        <h6 className=''>Go to My Deals when ready to redeem.</h6>
                                                    </div>
                                                </div>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>

                                            <Row>
                                                <Col xs={12}>

                                                    <Row className='tc-top-det'>
                                                        <Col lg={12}>
                                                            {/* <h6 className='fw-600'>Date : <span className='fw-600'>5/3/2025</span></h6> */}
                                                            <h6 className='fw-600'>Date : <span className='fw-600'>{moment(inputs.date).format("DD/MM/YY")}</span></h6>
                                                        </Col>
                                                        <Col lg={6} md={6} sm={6} xs={6}>
                                                            <h6 className='fw-600'>Deal ID : <span className='fw-600'>{inputs.deal_unique_id}</span></h6>
                                                        </Col>
                                                        <Col lg={6} md={6} sm={6} xs={6}>
                                                            <h6 className='fw-600'>Customer Name : <span>{inputs.customer_name}</span></h6>
                                                        </Col>
                                                    </Row>

                                                    <div className='tc-cont-box'>
                                                        <Row>
                                                            <Col md={4} sm={4} xs={4}>
                                                            {inputs.image ?
                                                                <Image src={inputs.image} className="img-fluid tc-deal-img" alt="location" />
                                                            : <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/default_deal.png'} className="img-fluid tc-deal-img" alt="cdeal5" />
                                                }
                                                            </Col>
                                                            <Col md={8} sm={8} xs={8} className='tcb-right'>
                                                            <h6>{inputs.listing_title}</h6>
                                                                {/*<h6><div
                                                        dangerouslySetInnerHTML={{
                                                            __html: inputs.description.replace(/\n/g, "<br/>")
                                                        }}
                                                    ></div></h6>*/}

                                                                {(() => {
                                                                    if (inputs.deal_master_type === 'specific') {
                                                                        if (inputs.deal_type === 1) {
                                                                            return (<><h6 className='fw-600'><strike><span>Rs. {inputs.original_mrp}</span></strike><span>Rs. {inputs.sale_price}</span><span class="peroff">{inputs.discount}% off</span></h6></>)
                                                                        } else if (inputs.deal_type === 2) {
                                                                            return (<><h6 className='fw-600'><span>Buy {inputs.buy_qty} Get {inputs.get_qty}</span></h6></>)
                                                                        }
                                                                    } else if (inputs.deal_master_type === 'general') {
                                                                        if (inputs.deal_type === 3) {
                                                                            return (<><h6 className='fw-600'><span>{inputs.store_percent_discount}% OFF</span></h6></>)
                                                                        } else if (inputs.deal_type === 4) {
                                                                            return (<><h6 className='fw-600'><span>{inputs.store_cash_discount} OFF</span></h6></>)
                                                                        }
                                                                    } else if (inputs.deal_master_type === 'free') {
                                                                        return (<><h6 className='fw-600' ><span className="text-danger">{inputs.free_item}</span></h6></>)
                                                                    }
                                                                })()}

                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                                <Col xs={12}>
                                                    <div className='tc-cont-box'>
                                                        <h6 className='tc-redeem'>Redeem the Deal coupon at -</h6>
                                                        <h5><Link to={`/neighbour/business-details/${inputs.slug}`}>{inputs.business_name}</Link></h5>
                                                        <div className='tc-icn-box'>
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} className="img-fluid d-none" alt="location" />
                                                            <h6>{inputs.address}</h6>
                                                        </div>
                                                        <div className='tc-icn-box'>
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/phone.webp'} className="img-fluid d-none" alt="phone" />
                                                            <h6>{inputs.contact_number}</h6>
                                                        </div>
                                                        <h6 className='fw-600 cc-text'>Coupon Code: <span>{inputs.coupon_code}</span></h6>
                                                        <div className='cvf-box'>
                                                            <h6>Coupon Valid From: {moment(inputs.date).format("DD/MM/YY")}</h6>
                                                            {inputs.deal_end_date !== '' && (<h6>Expires On : {moment(inputs.deal_end_date).format("D MMMM, YYYY")}</h6>)}
                                                        </div>
                                                        <div className='tc-bronze d-none'>
                                                            <h6>Coupon Code: 684567-79-1174</h6>
                                                            <h6>Coupon Valid From: 5/1/2025</h6>
                                                            <h6>Expires On : 7 June, 2025</h6>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className='tc-note'>
                                                <h6 className='tc-note-title'>Hot to Use it ?</h6>
                                                <ol>
                                                    <li><b>Visit the Merchant :</b> Go to merchant location mentioned in the Deal reservation.</li>
                                                    <li><b>Show the deal reservation coupon :</b> Open LocalBells → My Deals → Show reserved coupon and mark it as redeemed.</li>
                                                    <li><b>Pay to merchant directly :</b> Settle the bill directly with the merchant per offer; LocalBells charges no extra fees or commissions.</li>
                                                </ol>
                                            </div>
                                            
                                            <div className='tc-btn'>
                                                <div className='tc-btn-right'>
                                                    <Link to="/" className=''><h6>Download your coupon</h6> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/download.webp'} className="img-fluid" alt="download" /> </Link>
                                                    <Link to="#" onClick={shareAll}><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/share-th.webp'} className="img-fluid" alt="share-wh" /> </Link>
                                                </div>
                                            </div>
                                            <div className='tc-note'>
                                                <h6 className='tc-note-title'>For Merchants</h6>
                                                <h6 className="text-box">This deal is reserved and committed to honor as per your listing agreement on LocalBells.com. Please mark it as redeemed either from the customer’s app or from your Business Page under My Orders, then collect payment directly from the customer. LocalBells does not charge any commission or fees, so no other payment is required.</h6>
                                            </div>
                                            <div className='tc-btn-sec'>
                                                <div className='tc-btn-left'>
                                                    {inputs.redeem_status === 0 && (<Link className='blue-link' onClick={handleShow}>Redeem Coupon</Link>)}
                                                    <Link to="/neighbour/my-deals" className='blue-link'>Go to My Deals</Link>
                                                    <Link to="/neighbour/my-deals" className='blue-link'>Close</Link>
                                                </div>
                                            </div>
                                            <h6 className='tc-gen-txt'>Terms and Condition: Local Bells held no responsibility if seller deny the offer despite the reservation.</h6>
                                            <h6 className='tc-gen-txt'>In such cases, we request consumer to report fake offers to local belis via Report Fake Offer page. Localbelis assures to take necessary actions to remove such listing from the platform.</h6>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
                className='redeem-modal'
            >

                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <h3 className='text-center'>Do you confirm to Redeem Coupon?</h3>
                        </Col>
                        <Col md={6}>
                            <Link to="" onClick={handleClose} className='grey-link'>No</Link>
                        </Col>
                        <Col md={6}>
                            <Link to="" onClick={handleYes} className='blue-link'>Yes</Link>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default TransactionCompletion;


